module.exports = __webpack_public_path__ + "static/ch7-SCRUB-01-0da556b07954bd1f344406e3687f4fff.mp4";